import { Logger } from '_common/services';

export default abstract class BaseController {
  protected name: string = 'BaseController';

  Data: Editor.Data.State;
  private transportEvents: any;

  protected DEBUG = false;

  constructor(Data: Pick<Editor.Data.State, 'transport' | 'context'>) {
    this.Data = Data;
    this.transportEvents = {};
  }

  logMessage(type: 'DEBUG' | 'INFO' | 'WARN' | 'ERROR' | 'TRACE', message: string, ...args: any[]) {
    if (this.DEBUG) {
      const logMessage = `[${this.name}] ${message}`;
      switch (type) {
        case 'INFO':
          Logger.info(logMessage, ...args);
          break;
        case 'WARN':
          Logger.warn(logMessage, ...args);
          break;
        case 'ERROR':
          Logger.error(logMessage, ...args);
          break;
        case 'TRACE':
          Logger.trace(logMessage, ...args);
          break;
        case 'DEBUG':
        default:
          Logger.debug(logMessage, ...args);
          break;
      }
    }
  }

  protected registerTransportEvents(events: any) {
    const eventKeys = Object.keys(events) as Realtime.Transport.ServerEventName[];
    for (let i = 0; i < eventKeys.length; i++) {
      const event: Realtime.Transport.ServerEventName = eventKeys[i];
      if (!this.transportEvents[event]) {
        this.Data.transport.handleEvent(event, events[event]);
      }
    }
    this.transportEvents = {
      ...events,
      ...this.transportEvents,
    };
  }

  protected unregisterAllTransportEvents() {
    const eventKeys = Object.keys(this.transportEvents) as Realtime.Transport.ServerEventName[];
    for (let i = 0; i < eventKeys.length; i++) {
      const event = eventKeys[i];
      this.Data.transport.removeEvent(event, this.transportEvents[event]);
    }
  }

  abstract start(
    documentId?: string,
    data?: Realtime.Core.Document.Data,
    user?: Realtime.Core.User,
  ): void;
  abstract stop(): void;
  abstract destroy(): void;
}
